import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import useSettlementPaymentsSection from "../../hooks/useSettlementPaymentsSection";
import { SETTLEMENT_STYLES } from "../../style/styles";

import SettlementPaymentsModal from "./modal/SettlementPaymentsModal";
import SettlementPaymentsAddButton from "./SettlementPaymentsAddButton";
import SettlementPaymentsTable from "./SettlementPaymentsTable";

export default function SettlementPaymentsSection() {
  const {
    payments,
    paymentTypeOptions,
    paymentTypeDisplayMap,
    isLoading,
    caseDetail,
    canViewPayments,
    canAddPayments,
    canEditPayments,
    modalState,
    fetchPayments,
    handleOpenAddModal,
    handleOpenEditModal,
    handleCloseModal,
  } = useSettlementPaymentsSection();

  if (!canViewPayments) {
    return null;
  }

  return (
    <>
      <section
        className="flex min-h-[220px] max-h-[420px] flex-col overflow-hidden rounded-[12px] p-4 shadow-sm"
        style={SETTLEMENT_STYLES.sectionCard}
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Svg
              name={SvgEnum.HisPaymentCard}
              color={SETTLEMENT_STYLES.sectionIconColor}
              sx={SETTLEMENT_STYLES.sectionIcon}
            />
            <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
              Payments
            </h3>
          </div>
          {canAddPayments ? <SettlementPaymentsAddButton onClick={handleOpenAddModal} /> : null}
        </div>

        <div className="mt-4 flex min-h-0 flex-1 flex-col overflow-y-auto">
          <SettlementPaymentsTable
            data={payments}
            isLoading={isLoading}
            paymentTypeDisplayMap={paymentTypeDisplayMap}
            onEdit={handleOpenEditModal}
            canEdit={canEditPayments}
          />
        </div>
      </section>

      <SettlementPaymentsModal
        openModal={modalState.mode === "add" || modalState.mode === "edit"}
        caseId={caseDetail?.pk}
        caseDetail={caseDetail}
        mode={modalState.mode}
        paymentData={modalState.payment}
        paymentTypeOptions={paymentTypeOptions}
        handleCloseModal={handleCloseModal}
        onSaveSuccess={fetchPayments}
      />
    </>
  );
}
